import './Alert.css';

const iconos = {
  success: 'M20 6 9 17l-5-5',
  danger: 'M12 8v4M12 16h.01',
  warning: 'M12 9v4M12 17h.01',
  info: 'M12 16v-4M12 8h.01',
};

/** Mensaje de feedback. tone: 'success' | 'danger' | 'warning' | 'info' */
export default function Alert({ tone = 'info', title, children, className = '' }) {
  return (
    <div
      className={`alert alert-${tone} ${className}`}
      role={tone === 'danger' ? 'alert' : 'status'}
    >
      <span className="alert-icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          {tone !== 'success' && <circle cx="12" cy="12" r="10" />}
          <path d={iconos[tone]} />
        </svg>
      </span>
      <div>
        {title && <strong>{title}</strong>}
        {title && children && <br />}
        {children}
      </div>
    </div>
  );
}